import { LOAD_PROMO_CODES } from './type'
import { firestore } from '../utils/firebase'

export const loadPromoCodes = () => dispatch => {
    firestore.collection('promoCodes').orderBy('createdAt', 'desc').get().then(snapshot => {
        const promoCodes = {}
        snapshot.forEach(doc => {
            promoCodes[doc.id] = {
                id: doc.id,
                ...doc.data()
            }
        })

        dispatch({
            type: LOAD_PROMO_CODES,
            payload: promoCodes
        })
    })
}